import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { UriModule } from '®shared/url-utils';

import { ViewItemMenuComponent } from './view-item-menu.component';

@NgModule({
  imports: [CommonModule, BsDropdownModule, UriModule],
  declarations: [ViewItemMenuComponent],
  exports: [ViewItemMenuComponent],
})
export class ViewItemMenuModule {}
